<template>
    <div v-if="isModify">
        <div class="positionFixed">
            <div class="masking" @click="clickModifyPop"></div>
            <div class="tcCon">
                <div class="tcTit">
                    <span>{{$t("trade.products.modifyStopLoss")}}</span>
                </div>
                <div class="itemCon">
                    <div class="errInfo" v-if="errContent.length > 0">{{errContent[0]}}</div>
                    <div class="item3">
                        <p>{{$t("trade.products.type")}}</p>
                        <ul>
                            <li>
                                <input type="radio" name="radio" v-model="marketType.profit" value="1"
                                       @change="changeProfit()" class="radio" id="radio"/><label
                                    for="radio"><span></span></label>
                                <p>{{$t("trade.products.price")}}</p>
                            </li>
                            <!-- <li>
                                <input type="radio" name="radio" v-model="marketType.profit" value="2"
                                       @change="changeProfit()" class="radio" id="radio1"/><label
                                    for="radio1"><span></span></label>
                                <p>{{$t("trade.products.money")}}</p>
                            </li> -->
                        </ul>
                    </div>
                    <div v-if="ProfitLossChanges">
                        <div class="item1">
                            <!--买涨价+间隔点*pip/大点比率   买涨价+最大间隔点*pip/大点比-->
                            <p>{{$t("trade.products.stopProfit")}}<span
                                    :class="errClass.stopProfitClass">({{stopProfit.min}}-{{stopProfit.max}})</span>
                            <div class="border">
                                <div :class="market.stopProfit!='' && Number(market.stopProfit) <= Number(stopProfit.min)?'pic cut stop':'pic cut'"
                                     @click="changeStopProfit(1)"><img
                                        src="@/assets/images/template/a_chart_reduce.png"/></div>
                                <input v-model="market.stopProfit" :placeholder="$t('trade.products.notSet')"/>
                                <div :class="market.stopProfit!='' && Number(market.stopProfit) >= Number(stopProfit.max)?'pic add stop':'pic add'"
                                     @click="changeStopProfit(2)"><img
                                        src="@/assets/images/template/a_chart_increase.png"/></div>
                            </div>
                        </div>
                        <div class="item1">
                            <!--买涨价-最大间隔点*pip/大点比率  买涨价-间隔点*pip/大点比率-->
                            <p>{{$t("trade.products.stopLoss")}}<span
                                    :class="errClass.stopLossClass">({{stopLoss.min}}-{{stopLoss.max}})</span>
                            </p>
                            <div class="border">
                                <div :class="market.stopLoss!='' && Number(market.stopLoss) <= Number(stopLoss.min)?'pic cut stop':'pic cut'"
                                     @click="changeStopLoss(1)"><img
                                        src="@/assets/images/template/a_chart_reduce.png"/></div>
                                <input v-model="market.stopLoss" :placeholder="$t('trade.products.notSet')"/>
                                <div :class="market.stopLoss!='' && Number(market.stopLoss) >= Number(stopLoss.max)?'pic add stop':'pic add'"
                                     @click="changeStopLoss(2)"><img
                                        src="@/assets/images/template/a_chart_increase.png"/></div>
                            </div>
                        </div>
                    </div>
                    <div v-if="!ProfitLossChanges">
                        <div class="item1">
                            <!--买涨价+间隔点*pip/大点比率   买涨价+最大间隔点*pip/大点比-->
                            <p>{{$t("trade.products.stopProfit")}}<span :class="errClass.stopProfitClass">(${{stopProfit.min}}-${{stopProfit.max}})</span></p>
                            <div class="item_a">
                                <p><em>{{$t("trade.products.expectedProfit")}}</em><i class="rise" v-if="lossAndProfit.stopProfit && marketInfo.symbolData.marginInitial">{{(100*util.accDiv(lossAndProfit.stopProfit,position.Volume*marketInfo.symbolData.marginInitial)).toFixed(0)}}%</i></p>
                                <RangeScope v-if="!ProfitLossChanges" :minScope="stopProfit.min" :type="1" :rangeScope="stopProfit.max" :range="market.stopProfit" @changerange=changeRangeProfit></RangeScope>
                            </div>
                        </div>
                        <div class="item1">
                            <!--买涨价-最大间隔点*pip/大点比率  买涨价-间隔点*pip/大点比率-->
                            <p>{{$t("trade.products.stopLoss")}}<span :class="errClass.stopLossClass">(${{stopLoss.min}}-${{stopLoss.max}})</span></p>
                            <div class="item_a">
                                <p><em>{{$t("trade.products.expectedLoss")}}</em><i class="fall" v-if="lossAndProfit.stopLoss && marketInfo.symbolData.marginInitial">{{(100*util.accDiv(lossAndProfit.stopLoss,position.Volume*marketInfo.symbolData.marginInitial)).toFixed(0)}}%</i></p>
                                <RangeScope v-if="!ProfitLossChanges" :minScope="stopLoss.min" :type="2" :rangeScope="stopLoss.max" :range="market.stopLoss" @changerange=changeRangeLoss></RangeScope>
                            </div>
                        </div>
                    </div>
                    <div class="item2">
                        <ul>
                            <li>
                                <p>{{$t('trade.products.available')}} $<Available></Available></p>
                            </li>
                            <li v-if="lossAndProfit.stopProfit || lossAndProfit.stopLoss">
                                <p>{{$t('trade.products.expectedProfitLoss')}}
                                    <em v-if="lossAndProfit.stopProfit" :class="isOks(lossAndProfit.stopProfit)">{{lossAndProfit.stopProfit>=0?'+':'-'}}${{Math.abs(lossAndProfit.stopProfit).toFixed(2)}}</em>
                                    <em v-if="lossAndProfit.stopProfit && lossAndProfit.stopLoss">/</em>
                                    <em v-if="lossAndProfit.stopLoss" :class="isOks(lossAndProfit.stopLoss)">{{lossAndProfit.stopLoss>=0?'+':'-'}}${{Math.abs(lossAndProfit.stopLoss).toFixed(2)}}</em>
                                </p>
                            </li>
                        </ul>
                        <span @click="submit()" :class="errContent.length>0 || submitText==$t('message.submitting')?'err':''"><img
                                v-if="submitText==$t('message.submitting')"
                                src="@/assets/images/template/loading1.gif"/>{{submitText}}</span>
                    </div>
                </div>
            </div>
        </div>
        <!--提交失败提示-->
        <div class="popFixed" v-if="isError">
            <div class="masking" @click="errPop"></div>
            <div class="tcCon">
                <div class="item">
                    <p>{{errMessage}}</p>
                </div>
                <div class="btnCon only">
                    <span @click="errPop">{{$t("message.definite")}}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import Util from '@/utils/tradeDataUtil'
    import TradeUtil from '@/utils/tradeUtil'
    import Constant from '@/utils/Constant'
    import Available from '@/view/module/Available.vue'
    import RangeScope from '@/view/quotation/RangeScope.vue'

    export default {
        name: "ModifyStopLoss",
        components: {
            Available,
            RangeScope
        },
        props: ['position', 'code'],
        data() {
            return {
                submitText: this.$t("message.modify"),
                tradeUtil: TradeUtil,
                util: Util,
                isModify: false,
                marketType: {
                    profit: 1,//价格:1,点数:2
                },
                market: {stopLoss: "", stopProfit: ""},
                oldMarket: {},
                errMessage: '',
                isError: false,
                ProfitLossChanges:true,
            }
        },
        computed: {
            ...mapState(['quote', "symbolInfo", 'socket', 'account', 'positionUpdateRet', 'simpleResponse', 'group']),
            errMsg: {
                get() {
                    return ""
                }
            },
            marketInfo: {
                get() {
                    let symbolData = {};
                    let tick = {};
                    if (this.quote.notify[this.code]) {
                        const source = this.quote.notify[this.code].uiSourceCode;
                        if (this.symbolInfo.codeMap[source]) symbolData = this.symbolInfo.codeMap[source];
                    }
                    if (this.quote.codeTickMap && this.quote.codeTickMap[this.code]) tick = this.quote.codeTickMap[this.code];
                    return {
                        symbolData: symbolData,
                        tick: tick
                    };
                }
            },
            /*止损信息*/
            stopLoss: {
                get() {
                    return TradeUtil.stopLossMinAndMaxForPosition(this.position.OpenPrice, this.position.Direction == 1 ? this.marketInfo.tick.ask : this.marketInfo.tick.bid, this.marketInfo.symbolData, this.position.Direction, this.position.Volume, this.marketType.profit);
                }
            },
            /*止盈信息*/
            stopProfit: {
                get() {
                    return TradeUtil.stopProfitMinAndMaxForPosition(this.position.OpenPrice, this.position.Direction == 1 ? this.marketInfo.tick.ask : this.marketInfo.tick.bid, this.marketInfo.symbolData, this.position.Direction, this.position.Volume, this.marketType.profit);
                },
            },
            //预期盈亏
            lossAndProfit: {
                get() {
                    let loss = null, profit = null;//sub买卖差价
                    if (!this.position.ID) return {stopLoss: loss, stopProfit: profit};


                    if (this.market.stopLoss && this.market.stopLoss != "") { //亏
                        loss = TradeUtil.lossAndProfitForPosition(this.market.stopLoss, this.position.OpenPrice, this.marketInfo.symbolData, this.position.Volume, this.position.Direction, this.marketType.profit);
                    }
                    if (this.market.stopProfit && this.market.stopProfit != "") { //盈
                        profit = TradeUtil.lossAndProfitForPosition(this.market.stopProfit, this.position.OpenPrice, this.marketInfo.symbolData, this.position.Volume, this.position.Direction, this.marketType.profit);
                    }
                    return {
                        stopLoss: loss ? this.marketType.profit == 2 ? -loss : loss : null,
                        stopProfit: profit ? profit : null
                    }
                }
            },
            errClass: {
                get() {
                    let stopLossClass = this.market.stopLoss != '' && (Number(this.market.stopLoss) > Number(this.stopLoss.max) || Number(this.market.stopLoss) < Number(this.stopLoss.min)) ? 'err' : '';
                    let stopProfitClass = this.market.stopProfit != '' && (Number(this.market.stopProfit) > Number(this.stopProfit.max) || Number(this.market.stopProfit) < Number(this.stopProfit.min)) ? 'err' : '';
                    if (String(this.market.stopLoss).trim() == "-") stopLossClass = "err";
                    if (String(this.market.stopProfit).trim() == "-") stopProfitClass = "err";
                    return {
                        stopLossClass: stopLossClass,
                        stopProfitClass: stopProfitClass,
                    }
                },
            },
            errContent: {
                get() {
                    let arr = [];
                    if (this.market.stopLoss != '' && (Number(this.market.stopLoss) > Number(this.stopLoss.max) || Number(this.market.stopLoss) < Number(this.stopLoss.min))) arr.push(this.$t("message.modifyStopLoss.stopLossNoRange"));
                    if (this.market.stopProfit != '' && (Number(this.market.stopProfit) > Number(this.stopProfit.max) || Number(this.market.stopProfit) < Number(this.stopProfit.min))) arr.push(this.$t("message.modifyStopLoss.stopProfitNoRange"));
                    let stopLoss = this.market.stopLoss == "" ? 0 : this.marketType.profit == 1 ? this.market.stopLoss : TradeUtil.changePipValue(this.market.stopLoss, this.position.OpenPrice, this.position.OpenPrice, this.marketInfo.symbolData, this.position.Direction, 1, 1);
                    let stopProfit = this.market.stopProfit == "" ? 0 : this.marketType.profit == 1 ? this.market.stopProfit : TradeUtil.changePipValue(this.market.stopProfit, this.position.OpenPrice, this.position.OpenPrice, this.marketInfo.symbolData, this.position.Direction, 1, 2);
                    if (stopLoss == this.position.StopLoss && stopProfit == this.position.TakeProfit) {
                        //无任何修改时提示
                        arr.push(this.$t("message.modifyStopLoss.noModification"));
                    }
                    if (String(this.market.stopLoss).trim() == "-") arr.push(this.$t("message.modifyStopLoss.stopLossNoRange"));
                    if (String(this.market.stopProfit).trim() == "-") arr.push(this.$t("message.modifyStopLoss.stopProfitNoRange"));
                    return arr;
                },
                set(val) {

                }
            },
        },
        methods: {
            changeRangeLoss(range) {
                this.market.stopLoss = range;
            },
            changeRangeProfit(range) {
                this.market.stopProfit = range;
            },
            errPop() {
                this.isError = !this.isError;
            },
            clickModifyPop() {
                let mainH = document.getElementById("main");
                mainH.classList.toggle('mainFixed');
                this.isModify = !this.isModify;
                /*初始化止损止盈价格*/
                if (this.position.StopLoss && Number(this.position.StopLoss) != 0) this.market.stopLoss = this.position.StopLoss;
                if (this.position.TakeProfit && Number(this.position.TakeProfit) != 0) this.market.stopProfit = this.position.TakeProfit;
            },
            /*止损止盈价格点数切换*/
            changeProfit() {
                this.ProfitLossChanges = !this.ProfitLossChanges;
                if (this.market.stopLoss && this.market.stopLoss != "") {
                    this.market.stopLoss = TradeUtil.changePipValueForPosition(this.market.stopLoss, this.position.OpenPrice, this.marketInfo.symbolData, this.position.Direction, this.marketType.profit, 1, this.position.Volume);
                }
                if (this.market.stopProfit && this.market.stopProfit != "") {
                    this.market.stopProfit = TradeUtil.changePipValueForPosition(this.market.stopProfit, this.position.OpenPrice, this.marketInfo.symbolData, this.position.Direction, this.marketType.profit, 2, this.position.Volume);
                }
            },
            changeStopLoss(type) {
                if (!this.market.stopLoss || this.market.stopLoss == "") {
                    if (this.marketType.profit == 2) this.market.stopLoss = this.stopLoss.min;
                    else this.market.stopLoss = this.position.Direction == 1 ? this.stopLoss.max : this.stopLoss.min;
                    return;
                }
                const fix = this.marketInfo.symbolData.digits;
                if (type == 1) {
                    if (this.marketType.profit == 1) {
                        //价格
                        this.market.stopLoss = Number(Util.accSub(Number(this.market.stopLoss), Number(this.marketInfo.symbolData.pipv))).toFixed(fix);
                        //超出范围弹出提示
                    } else {
                        //点数
                        this.market.stopLoss = Number(Util.accSub(Number(this.market.stopLoss), Number(1))).toFixed(1);
                    }
                    if (Number(this.market.stopLoss) <= Number(this.stopLoss.min)) {
                        this.market.stopLoss = Number(this.stopLoss.min).toFixed(this.marketType.profit == 1 ? fix : 1);
                    }
                } else {
                    //加
                    if (this.marketType.profit == 1) {
                        //价格
                        this.market.stopLoss = Number(Util.accAdd(Number(this.market.stopLoss), Number(this.marketInfo.symbolData.pipv))).toFixed(fix);
                    } else {
                        this.market.stopLoss = Number(Util.accAdd(Number(this.market.stopLoss), Number(1))).toFixed(1);
                    }
                    if (Number(this.market.stopLoss) >= Number(this.stopLoss.max)) {
                        this.market.stopLoss = Number(this.stopLoss.max).toFixed(this.marketType.profit == 1 ? fix : 1);
                    }
                }
            },
            changeStopProfit(type) {
                if (!this.market.stopProfit || this.market.stopProfit == "") {
                    if (this.marketType.profit == 2) this.market.stopProfit = this.stopProfit.min;
                    else this.market.stopProfit = this.position.Direction == 1 ? this.stopProfit.min : this.stopProfit.max;
                    return;
                }
                const fix = this.marketInfo.symbolData.digits;
                if (type == 1) {
                    //减
                    if (this.marketType.profit == 1) {
                        //价格
                        this.market.stopProfit = Number(Util.accSub(Number(this.market.stopProfit), Number(this.marketInfo.symbolData.pipv))).toFixed(fix);
                    } else {
                        //点数
                        this.market.stopProfit = Number(Util.accSub(Number(this.market.stopProfit), Number(1))).toFixed(1);
                    }
                    if (Number(this.market.stopProfit) <= Number(this.stopProfit.min)) {
                        this.market.stopProfit = Number(this.stopProfit.min).toFixed(this.marketType.profit == 1 ? fix : 1);
                    }
                } else {
                    //加
                    if (this.marketType.profit == 1) {
                        //价格
                        this.market.stopProfit = Number(Util.accAdd(Number(this.market.stopProfit), Number(this.marketInfo.symbolData.pipv))).toFixed(fix);
                    } else {
                        //点数
                        this.market.stopProfit = Number(Util.accAdd(Number(this.market.stopProfit), Number(1))).toFixed(1);
                    }
                    if (Number(this.market.stopProfit) >= Number(this.stopProfit.max)) {
                        this.market.stopProfit = Number(this.stopProfit.max).toFixed(this.marketType.profit == 1 ? fix : 1);
                    }
                }
            },
            submit() {
                let mainH = document.getElementById("main");
                mainH.classList.toggle('mainFixed');
                if (this.errContent.length > 0 || this.submitText == this.$t('message.submitting')) return;
                this.submitText = this.$t('message.submitting');
                let req = TradeUtil.getPositionProfitLossReq(this.account, this.marketInfo.symbolData, this.position);
                const fix = this.marketInfo.symbolData.digits;
                //止损止盈
                if (this.market.stopLoss && this.market.stopLoss != "") {
                    if (this.marketType.profit == 1) req.StopLoss = Number(this.market.stopLoss).toFixed(fix);
                    else if (this.marketType.profit == 2) {
                        req.StopLoss = TradeUtil.changePipValueForPosition(this.market.stopLoss, this.position.OpenPrice, this.marketInfo.symbolData, this.position.Direction, 1, 1, this.position.Volume);
                    }
                }
                if (this.market.stopProfit && this.market.stopProfit != "") {
                    if (this.marketType.profit == 1) req.TakeProfit = Number(this.market.stopProfit).toFixed(fix);
                    if (this.marketType.profit == 2) {
                        req.TakeProfit = TradeUtil.changePipValueForPosition(this.market.stopProfit, this.position.OpenPrice, this.marketInfo.symbolData, this.position.Direction, 1, 2, this.position.Volume);
                    }
                }
                this.socket.tradeSocket.emit('request', Number(Constant.Req.profitloss), req);
            },
            isOks: function (obj) {
                let val = "";
                if (obj > 0) {
                    val = "rise"
                } else if (obj == 0) {
                    val = "level"
                } else {
                    val = "fall"
                }
                return val;
            },
        },
        watch: {
            market: {
                //监听数据格式长度等
                deep: true,
                handler(newValue, oldValue) {
                    //止损价控制
                    if (newValue.stopLoss && newValue.stopLoss != "") {
                        if (isNaN(newValue.stopLoss) || String(newValue.stopLoss).indexOf("e") >= 0) {
                            if (String(newValue.stopLoss).trim() != "-" || this.marketType.profit == 1) this.market.stopLoss = this.oldMarket.stopLoss;
                        } else {
                            if (String(newValue.stopLoss).indexOf("-") >= 0 && this.marketType.profit == 1) this.market.stopLoss = this.oldMarket.stopLoss;
                            if (String(newValue.stopLoss).indexOf(".") > 0 && this.marketInfo.symbolData) {
                                if (this.marketType.profit == 1 && String(newValue.stopLoss).split(".")[1].length > this.marketInfo.symbolData.digits) {
                                    this.market.stopLoss = this.oldMarket.stopLoss;
                                } else if (this.marketType.profit == 2 && String(newValue.stopLoss).split(".")[1].length > 2) {
                                    this.market.stopLoss = this.oldMarket.stopLoss;
                                }
                            }
                        }
                    }
                    //止盈价控制
                    if (newValue.stopProfit && newValue.stopProfit != "") {
                        if (isNaN(newValue.stopProfit) || String(newValue.stopProfit).indexOf("e") >= 0) {
                            if (String(newValue.stopProfit).trim() != "-" || this.marketType.profit == 1) this.market.stopProfit = this.oldMarket.stopProfit;
                        } else {
                            if (String(newValue.stopProfit).indexOf("-") >= 0 && this.marketType.profit == 1) this.market.stopProfit = this.oldMarket.stopProfit;
                            if (String(newValue.stopProfit).indexOf(".") > 0 && this.marketInfo.symbolData) {
                                if (this.marketType.profit == 1 && String(newValue.stopProfit).split(".")[1].length > this.marketInfo.symbolData.digits) {
                                    this.market.stopProfit = this.oldMarket.stopProfit;
                                } else if (this.marketType.profit == 2 && String(newValue.stopProfit).split(".")[1].length > 2) {
                                    this.market.stopProfit = this.oldMarket.stopProfit;
                                }
                            }
                        }
                    }
                    this.oldMarket = TradeUtil.copy(this.market);
                }
            },
            simpleResponse: {
                //提交失败提示
                deep: true,
                handler(newValue, oldValue) {
                    this.submitText = this.$t("message.modify");
                    this.errMessage = this.tradeUtil.getFailMsg(newValue.Code, this.marketInfo.symbolData, this.group);
                    this.isError = !this.isError;
                    let mainH = document.getElementById("main");
                    mainH.classList.toggle('mainFixed');
                }
            },
            positionUpdateRet: {
                deep: true,
                handler(newValue, oldValue) {
                    if (newValue.ID && this.position && this.position.ID && newValue.MsgId == 1704) {
                        if (newValue.ID == this.position.ID) {
                            //修改成功
                            let data = TradeUtil.copy(newValue);
                            if (this.marketType.profit == 2) {
                                data.setStopLossTip = this.market.stopLoss;
                                data.setStopProfitTip = this.market.stopProfit;
                            }
                            this.isModify = false;
                            this.submitText = this.$t("message.modify");
                            this.$router.replace({path: '/home/modifySuc', query: data});
                        }
                    }
                },
            }
        },
    }
</script>
